import { Navigate } from 'react-router-dom';
import { usePointEnabled } from '@/common/hooks';
import LoadingSpinner from '@/components/common/elements/LoadingSpinner';

interface PointFeatureRouteProps {
    children: React.ReactNode;
}

/**
 * 포인트 기능 flag(myungchisa.feature.point.enabled)가 꺼져 있으면
 * 포인트 관련 화면(충전/상품구매/구매내역) 접근을 홈으로 돌려보낸다.
 * 메뉴에서 숨겨도 URL 직접 접근이 가능했던 구멍을 막는 용도.
 */
const PointFeatureRoute = ({ children }: PointFeatureRouteProps) => {
    const { pointEnabled, pointFlagLoaded } = usePointEnabled();

    if (!pointFlagLoaded) {
        return <LoadingSpinner placement="page" minHeight="40vh" />;
    }

    if (!pointEnabled) {
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
};

export default PointFeatureRoute;
